import React, { Component } from "react";

interface Props {
  text: string;
  type: string;
  size?: string;
  className?: string;
  onClick?: (e: any) => void;
}

export default class Button extends Component<Props> {
  render() {
    let defaultSize = "px-5 py-3";
    if (this.props.size === "small") {
      defaultSize = "px-3 py-2";
    }

    let defaultClassName = `block rounded-md border border-transparent ${defaultSize} text-base font-medium shadow focus:outline-none focus:ring-2 focus:ring-offset-2 sm:px-10`;

    if (this.props.className) {
      defaultClassName += ` ${this.props.className}`;
    }

    if (this.props.type) {
      switch (this.props.type) {
        case "normal":
          defaultClassName +=
            " bg-blue-600 text-white hover:bg-blue-500 focus:ring-blue-600";
          break;
        case "dark":
          defaultClassName +=
            " bg-blue-800 text-white hover:bg-blue-900 focus:ring-offset-white";
          break;
        case "light":
          defaultClassName +=
            " bg-white text-blue-600 hover:bg-gray-100 focus:ring-blue-700";
          break;
      }
    }

    return (
      <button
        type="button"
        className={defaultClassName}
        onClick={this.props.onClick}
      >
        {this.props.text}
      </button>
    );
  }
}
